// extracted by mini-css-extract-plugin
module.exports = {"department":"styles_department__4MWGa","department_span":"styles_department_span__1jVYe"};